export const categoriesArray = [
    'BUSINESS',
    'EDUCATION',
    'FINANCE',
    'FITNESS',
    'DESIGN',
    'ENGINEERING',
    'HEALTHCARE',
    'HUMAN_RESOURCE',
    'LEADERSHIP',
    'LEGAL',
    'MANUFACTURING',
    'MARKETING',
    'PERSONAL_DEVELOPMENT',
    'RESEARCH_AND_DEVELOPMENT',
    'SALES',
    'SOFTWARE',
    'TECHNOLOGY',
    'GENERAL'
];

export const categoriesIcon = {
    BUSINESS: 'business',
    EDUCATION: 'school',
    FINANCE: 'multiline_chart',
    FITNESS: 'fitness_center',
    DESIGN: 'palette',
    ENGINEERING: 'build',
    HEALTHCARE: 'healing',
    HUMAN_RESOURCE: 'supervisor_account',
    LEADERSHIP: 'directions_run',
    LEGAL: 'account_balance',
    MANUFACTURING: 'location_city',
    MARKETING: 'pie_chart',
    PERSONAL_DEVELOPMENT: 'local_library',
    RESEARCH_AND_DEVELOPMENT: 'find_in_page',
    SALES: 'attach_money',
    SOFTWARE: 'computer',
    TECHNOLOGY: 'router',
    GENERAL: 'label'
};

export const homePageCategoriesArray = [
    'ANY',
    'BUSINESS',
    'EDUCATION',
    'TECHNOLOGY',
    'SOFTWARE',
    'HEALTHCARE',
    'MARKETING',
    'FINANCE',
    'SALES',
    'PERSONAL_DEVELOPMENT',
    'LEADERSHIP',
    'HUMAN_RESOURCE',
    'ENGINEERING',
    'RESEARCH_AND_DEVELOPMENT',
    'FITNESS',
    'LEGAL',
    'MANUFACTURING',
    'DESIGN',
];




// WEBPACK FOOTER //
// ./src/components/SharedComponents/categories.js